import type { Organization } from 'schema-dts'

export const useGlobalStructuredData = () => {
  const { locale } = useI18n()
  const { getBaseURL } = useURL()
  const { phoneNumber } = useContactPhoneNumber()

  const organization = computed<Organization>(() => {
    const baseURL = `${getBaseURL()}/${locale.value}`

    return {
      '@type': 'Organization',
      '@id': `${baseURL}#organization`,
      name: 'Le Collectionist',
      url: baseURL,
      logo: 'https://cdn.lecollectionist.com/__collectionist__/production/assets/images/lecollectionist-luxury-villas-rentals-holidays.svg',
      foundingDate: '2014',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '65 Rue de la Victoire',
        addressLocality: 'Paris',
        postalCode: '75009',
        addressCountry: 'FR',
      },
      telephone: phoneNumber.value,
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: phoneNumber.value,
          contactType: 'customer service',
          areaServed: 'Worldwide',
          availableLanguage: ['French', 'English'],
          email: 'contact@lecollectionist.com',
        },
        {
          '@type': 'ContactPoint',
          telephone: phoneNumber.value,
          contactType: 'sales',
          areaServed: 'Worldwide',
          availableLanguage: ['French', 'English'],
        },
      ],
      award: [
        'Condé Nast Traveller Readers’ Choice Awards 2024',
        'B-Corporation Certification 2022',
      ],
      sameAs: [
        'https://www.facebook.com/lecollectionist',
        'https://www.instagram.com/lecollectionist',
        'https://www.linkedin.com/company/le-collectionist',
        'https://www.youtube.com/channel/UCiED1oKWDWR2JDusPRkonuw',
      ],
    }
  })

  return { organization }
}
